// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsvideoconfig = {
    "awsInputVideo": "properiesvodstream-dev-input-1lxg6thx",
    "awsOutputVideo": "didsugvpn60.cloudfront.net"
};

export default awsvideoconfig;